import * as d3 from 'd3';
import { entries, map, Map } from 'd3-collection';
import { Component, h } from 'preact';

import topology from 'Assets/geography/texas_urban.json';

import appData from 'Data/data.json';

const countiesData = appData;

import prepareTopoJSON from '../utils/prepare-topojson';

import { TIE } from '../colors';

interface Props {
  category: string;
  contest: { [key: string]: any };
  candidatesRender: any;
}

class TinyMap extends Component<Props> {
  candidateMap!: Map<any>;
  countyMap!: Map<any>;

  constructor() {
    super();

    this.createMap = this.createMap.bind(this);
    this.redrawMap = this.redrawMap.bind(this);
    this.findLeading = this.findLeading.bind(this);
  }

  setUpCandidateMap(candidates: any) {
    this.candidateMap = map(candidates, (d) => d.id);
  }

  setUpCountyMap(counties: any) {
    this.countyMap = map(counties, (d) => d.fips);
  }

  componentDidMount() {
    const { category, contest } = this.props;

    this.setUpCandidateMap(contest.candidacies);
    this.setUpCountyMap(contest.counties);

    this.createMap(contest, category);

    window.addEventListener('resize', () => {
      this.redrawMap();
    });
  }

  componentDidUpdate() {
    const { category, contest } = this.props;

    this.setUpCandidateMap(contest.candidacies);
    this.setUpCountyMap(contest.counties);

    this.createMap(contest, category);
  }

  findLeading(fips) {
    const { candidatesRender } = this.props;

    const county = this.countyMap.get(fips);

    let fillStyle;

    if (!county || county.total_votes <= 0) {
      fillStyle = '#666';
    } else {
      const sortedResults = entries(county.results).sort(
        (a, b) => b.value - a.value
      );

      const leader = sortedResults[0];
      const second = sortedResults[1];

      if (!leader || !second) {
        fillStyle = '#666';
      } else if (leader.value === second.value) {
        fillStyle = TIE;
      } else {
        const leadingId = leader.key;

        const candidateObj = this.candidateMap.get(leadingId);
        if (!candidateObj) {
          fillStyle = '#666';
        } else {
          const result = candidatesRender.filter((cand) => cand.id == candidateObj.id);
          fillStyle = result.length > 0 ? result[0]['color'] : '#bdbdbd';
        }
      }
    }

    return fillStyle;
  }

  createMap(contest, category) {
    d3.selectAll(`.${category}-${contest.office_slug}-${contest.party.toLowerCase()} svg`).remove();

    const container = d3.select(`.${category}-${contest.office_slug}-${contest.party.toLowerCase()}`);

    const geos = prepareTopoJSON(topology);

    let projection = d3
      .geoIdentity()
      .reflectY(true)
      .fitSize([75, 75], geos.collection);

    let pathGenerator = d3.geoPath().projection(projection);

    let tinymap = container
      .append('svg')
      .attr('id', 'tinymap')
      .attr('role', 'presentation')
      .attr('width', 75)
      .attr('height', 75);

    let g_tinymap = tinymap
      .append('g')
      .attr('class', 'tinymap')
      .attr('width', 75)
      .attr('height', 75);

    g_tinymap
      .selectAll('.tinycounties')
      .data(geos.collection.features)
      .enter()
      .append('path')
      .attr('d', pathGenerator)
      .attr('stroke', (d) => {
        let foundCounty = countiesData.counties.find(
          (a) => a.county == d.properties.name
        );
        if (foundCounty && foundCounty.category == category)
          return this.findLeading(d.properties.fips);
        else return '#d0d0d0';
      })
      .attr('stroke-width', '1')
      .attr('class', 'tinycounties')
      .attr('fill', (d) => {
        let foundCounty = countiesData.counties.find(
          (a) => a.county == d.properties.name
        );
        if (foundCounty && foundCounty.category == category)
          return this.findLeading(d.properties.fips);
        else return '#d0d0d0';
      });
  }

  redrawMap() {
    const { category, contest } = this.props;

    d3.selectAll(`.${category}-${contest.office_slug}-${contest.party.toLowerCase()} svg`).remove();
    this.createMap(contest, category);
  }

  render() {
    const { category, contest } = this.props;

    return (
      <div
        id='tinymapcontainer'
        class={`${category}-${contest.office_slug}-${contest.party.toLowerCase()}`}
      ></div>
    );
  }
}

export default TinyMap;
